import { createSlice } from '@reduxjs/toolkit';
import { ConnectionStateProps } from '../../../types/Layout';

const initialState: ConnectionStateProps = {
  pgConnected: false,
  redisConnected: false,
  attendeeBotConnected: false,
};
const ConnectionSlice = createSlice({
  name: 'connection',
  initialState,
  reducers: {
    setPgConnection: (state, action) => {
      state.pgConnected = action.payload;
    },
    setRedisConnection: (state, action) => {
      state.redisConnected = action.payload;
    },
    setAttendeeBotConnection: (state, action) => {
      state.attendeeBotConnected = action.payload;
    },
  },
});

export const { setPgConnection, setRedisConnection, setAttendeeBotConnection } =
  ConnectionSlice.actions;
export default ConnectionSlice.reducer;